<template>
  <v-row no-gutters class="pb-6">
    <v-col cols="5" class="text-start align-content-center">
      <v-switch
        v-model="horseWithoutParticipant"
        label="Chevaux réservés"
        color="third"
        class="mt-0 d-inline-block"
        hide-details
      />
    </v-col>
    <v-col cols="4" class="pr-2">
      <v-select
        v-model="selectedLevels"
        dense
        label="Niveau du cheval"
        :items="levels"
        item-value="uuid"
        item-text="name"
        :chips="showItemInChips"
        persistent
        clearable
        :menu-props="{ 'z-index': '95000 !important'}"
        color="black"
        item-color="third"
        :multiple="true"
        hide-details
        :loading="levelsLoading"
      />
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="selectedHorseTypes"
        dense
        label="Type de cheval"
        :items="horsesType"
        item-value="value"
        item-text="label"
        :chips="showItemInChips"
        persistent
        clearable
        :menu-props="{ 'z-index': '95000 !important'}"
        color="black"
        item-color="third"
        :multiple="true"
        hide-details
      >
        <template #prepend-item>
          <v-list-item
            ripple
            @mousedown.prevent
            @click="selectAll"
          >
            <v-list-item-action>
              <v-icon :color="selectedHorseTypes.length > 0 ? 'third darken-1' : ''">
                {{ icon() }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Tous
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2" />
        </template>
        <template #selection="{ item, index }">
          <v-chip v-if="selectedHorseTypes.length === horsesType.length && index === 0">
            <span>Tous</span>
          </v-chip>
          <v-chip v-else-if="selectedHorseTypes.length !== horsesType.length" class="my-1">
            <span>{{ item.label }}</span>
          </v-chip>
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
import { inject, ref, computed, onBeforeMount } from '@vue/composition-api';

import { getLevels } from '@/helpers/request';

import store from '@/store';

export default {
  props: {
    showItemInChips: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    const levelsLoading = ref(false);
    const horseWithoutParticipant = inject('horseWithoutParticipant');
    const selectedHorseTypes = inject('selectedHorseTypes');
    const selectedLevels = inject('levelsList');
    const levels = ref([]);

    const references = computed(() => store.getters.referenceByName('equestrianType'));

    const horsesType = ref([
      ...references.value
    ]);

    const selectAll = () => {
      if (selectedHorseTypes.value.length && selectedHorseTypes.value.length === horsesType.value.length) {
        selectedHorseTypes.value = [];
      } else {
        selectedHorseTypes.value = horsesType.value.map(horseType => horseType.value);
      }
    };

    const icon = () => {
      if (selectedHorseTypes.value.length && selectedHorseTypes.value.length === horsesType.value.length) return 'mdi-close-box';
      if (selectedHorseTypes.value.length && selectedHorseTypes.value.length !== horsesType.value.length) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    };

    onBeforeMount(async () => {
      levelsLoading.value = true;
      const response = await getLevels();
      levelsLoading.value = false;

      if (response.success && response.data?.length) {
        levels.value = response.data;
      }
    });

    return { icon, selectAll, horseWithoutParticipant, selectedHorseTypes, horsesType, levels, selectedLevels, levelsLoading };
  }
};

</script>
